import { BadgeCheck, Crown } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function GoodPayerBadge({ size = "sm", className = "", tip = true, level = "bom" }) {
  const cls = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1";
  const excelente = level === "excelente";
  const color = excelente
    ? "border-amber-400/50 bg-amber-400/15 text-amber-300"
    : "border-emerald-500/40 bg-emerald-500/15 text-emerald-300";
  const Icon = excelente ? Crown : BadgeCheck;
  const label = excelente ? "Excelente Pagador" : "Bom Pagador";
  const badge = (
    <span data-testid={`payer-badge-${level}`}
      className={`inline-flex items-center gap-1 rounded-sm border font-semibold whitespace-nowrap cursor-help ${color} ${cls} ${className}`}>
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />{label}
    </span>
  );
  if (!tip) return badge;
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent className="max-w-[260px] bg-[#1C1C24] border-white/10 text-zinc-200" data-testid="payer-tooltip">
          {excelente
            ? "Reputação financeira máxima: histórico consistente de pagamentos, 100% no prazo e sem pendências."
            : "Organizador com histórico financeiro confiável: pagamentos realizados no prazo e sem pendências."}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
